const isDevEnv = import.meta.env.DEV == true
function log(title: string, ...args: unknown[]) {
	if (isDevEnv) {
		console.debug(`-- ${title}`, ...args)
	}
}

export { log, isDevEnv }
